import Vue from "vue";

import NavBar from '../../components/NavBar';

import { Form, Field, Button, Toast, Icon, Popup, Dialog } from "vant";

Vue.component("nav-bar", NavBar);

Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Dialog);